import router from '../routes/router';
import { getNewsUrl } from './builders';
import { getSettings } from './selectors';

export function navigate(lastSearch, newSearch) {
	const search = { ...lastSearch, ...newSearch };
	router.navigate('list', search);
}

export function navigateFacet( newSearch) {
	const search = { ...newSearch };
	router.navigate('list', search);
}

export function toUrl(lastSearch, newSearch, settings) {
	const search = { ...lastSearch, ...newSearch };
		return router.buildUrl('list', search);
}

export function addFilter(lastSearch, filterName, value, checked) {
	let currentFilter = (lastSearch || {})[filterName];
	currentFilter = !!currentFilter ? currentFilter.toString().split(',') : [];
	let index = currentFilter.indexOf(value);		
	if (!checked && (index >= 0)) {
		currentFilter = currentFilter.filter(v => v !== value);
	}
	if (checked && (index < 0)) {
		currentFilter = [...currentFilter, value];	
	}
	navigate(lastSearch, { [filterName]: currentFilter.toString(), pageIndex: 0 });
}

export function toggleFilter(lastSearch, filterName, value){
	lastSearch[filterName] = value;
	navigate(lastSearch, { [filterName]: value, pageIndex: 0 });
}

export function changeDateFilter(lastSearch, filterName, value) {	
	const currentDate = new Date();
	if (!!value && filterName == 'Year' && new Date(value, lastSearch.month - 1) >= currentDate) {
		navigate(lastSearch, { month: currentDate.getMonth() + 1, [filterName]: value, pageIndex: 0 });
	}
	else {
		changeFilter(lastSearch, filterName, value);
	}
}

export function removeAdvancedFilters(lastSearch, filterNames){
	let value = null
	if(filterNames){
		let newSearch = Object.keys(lastSearch).filter(key => filterNames.indexOf(key) > -1 && lastSearch[key])
		.map(key => {delete lastSearch[key]});
		navigate(lastSearch, newSearch)
	}
}

export function changeFilter(lastSearch, filterName, value) {
	navigate(lastSearch, { [filterName]: value, pageIndex: 0 });
}


export function changeSchemesFilter(lastSearch, filterName, value) {	

	changeFilter(lastSearch, filterName, value);

}

export function changeFilters(lastSearch, filters) {
    navigate(lastSearch, { ...filters, pageIndex: 0 });
}
